import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {ShopsProps, Shops} from './Shops';

export interface ShopsSectionProps extends ShopsProps {
  locale: string;
}

let manager = new I18nManager({locale: 'en-CA'});

export function ShopsSection(props: ShopsSectionProps) {
  const {locale, ...restProps} = props;

  if (locale && locale !== 'en-CA') {
    manager = new I18nManager({locale});
  }

  return (
    <I18nContext.Provider value={manager}>
      <Shops {...restProps} />
    </I18nContext.Provider>
  );
}

export default renderReact('Shops', ShopsSection);
